var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPlayS48Line = function SvgIconPlayS48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.11 33.7c-.5 0-1-.13-1.44-.38-.9-.52-1.46-1.48-1.46-2.52V17.2c0-1.04.56-2 1.46-2.52.9-.51 2.01-.51 2.91.01l11.6 6.8c.9.53 1.43 1.46 1.43 2.5s-.54 1.97-1.43 2.5l-11.6 6.8c-.45.26-.96.4-1.47.4v.01Zm.5-15.62v11.85L29.72 24l-10.11-5.92Z",
    fill: "current"
  })));
};
export default SvgIconPlayS48Line;